import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const useGoodsSearch = (id: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useGoodscontext---------", context.useApiError);
  const { set: setError } = useApiError();
  // Shared ref holding the response from the API
  const result = sharedRef(null, `useGoodsSearch-${id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useGoodsSearch-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `useGoodsSearch-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const search = async (customQuery) => {
    try {
      loading.value = true;
      result.value = null;
      const res = await context.$xbuy.api.productSearch(customQuery);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value.load = null;
      } else {
        error.value.load = new Error(res.message);
        result.value = null;
        setError({ code: res.code, message: res.message });
      }
    } catch (err) {
      error.value.load = err;
      result.value = null;
    } finally {
      loading.value = false;
    }
  };

  return {
    search,
    goodsResult: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
